/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './affiliation-brief.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/common';
import * as i3 from '../../../../../app/shared/components/affiliation-brief/affiliation-brief.component';
const styles_AffiliationBriefComponent:any[] = [i0.styles];
export const RenderType_AffiliationBriefComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_AffiliationBriefComponent,data:{}});
function View_AffiliationBriefComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),2,'span',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i1.ɵted(1,(null as any),['',''])),(_l()(),i1.ɵeld(2,0,(null as any),(null as any),
      0,'br',([] as any[]),(null as any),(null as any),(null as any),(null as any),
      (null as any)))],(null as any),(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.affiliation.ICN[0];
    _ck(_v,1,0,currVal_0);
  });
}
function View_AffiliationBriefComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),2,'span',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i1.ɵted(1,(null as any),['',''])),(_l()(),i1.ɵeld(2,0,(null as any),(null as any),
      0,'br',([] as any[]),(null as any),(null as any),(null as any),(null as any),
      (null as any)))],(null as any),(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.affiliation.institution_names[0];
    _ck(_v,1,0,currVal_0);
  });
}
export function View_AffiliationBriefComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(2,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'strong',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i1.ɵted(1,(null as any),['',''])),(_l()(),i1.ɵeld(2,0,(null as any),(null as any),
      0,'br',([] as any[]),(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n'])),(_l()(),i1.ɵeld(4,
      0,(null as any),(null as any),7,'small',([] as any[]),(null as any),(null as any),
      (null as any),(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),
      ['\n  '])),(_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),
      View_AffiliationBriefComponent_1)),i1.ɵdid(7,16384,(null as any),0,i2.NgIf,[i1.ViewContainerRef,
      i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),
      ['\n  '])),(_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),
      View_AffiliationBriefComponent_2)),i1.ɵdid(10,16384,(null as any),0,i2.NgIf,
      [i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),
      i1.ɵted(-1,(null as any),['\n']))],(_ck,_v) => {
    var _co:i3.AffiliationBriefComponent = _v.component;
    const currVal_1:any = _co.isNotEmpty(_co.affiliation.ICN);
    _ck(_v,7,0,currVal_1);
    const currVal_2:any = _co.isNotEmpty(_co.affiliation.institution_names);
    _ck(_v,10,0,currVal_2);
  },(_ck,_v) => {
    var _co:i3.AffiliationBriefComponent = _v.component;
    const currVal_0:any = _co.affiliation.legacy_ICN;
    _ck(_v,1,0,currVal_0);
  });
}
export function View_AffiliationBriefComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'re-affiliation-brief',
      ([] as any[]),(null as any),(null as any),(null as any),View_AffiliationBriefComponent_0,
      RenderType_AffiliationBriefComponent)),i1.ɵdid(1,49152,(null as any),0,i3.AffiliationBriefComponent,
      ([] as any[]),(null as any),(null as any))],(null as any),(null as any));
}
export const AffiliationBriefComponentNgFactory:i1.ComponentFactory<i3.AffiliationBriefComponent> = i1.ɵccf('re-affiliation-brief',
    i3.AffiliationBriefComponent,View_AffiliationBriefComponent_Host_0,{affiliation:'affiliation'},
    {},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvdHJhdmlzL2J1aWxkL2luc3BpcmVoZXAvcmVjb3JkLWVkaXRvci9zcmMvYXBwL3NoYXJlZC9jb21wb25lbnRzL2FmZmlsaWF0aW9uLWJyaWVmL2FmZmlsaWF0aW9uLWJyaWVmLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9ob21lL3RyYXZpcy9idWlsZC9pbnNwaXJlaGVwL3JlY29yZC1lZGl0b3Ivc3JjL2FwcC9zaGFyZWQvY29tcG9uZW50cy9hZmZpbGlhdGlvbi1icmllZi9hZmZpbGlhdGlvbi1icmllZi5jb21wb25lbnQudHMiLCJuZzovLy9ob21lL3RyYXZpcy9idWlsZC9pbnNwaXJlaGVwL3JlY29yZC1lZGl0b3Ivc3JjL2FwcC9zaGFyZWQvY29tcG9uZW50cy9hZmZpbGlhdGlvbi1icmllZi9hZmZpbGlhdGlvbi1icmllZi5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUvdHJhdmlzL2J1aWxkL2luc3BpcmVoZXAvcmVjb3JkLWVkaXRvci9zcmMvYXBwL3NoYXJlZC9jb21wb25lbnRzL2FmZmlsaWF0aW9uLWJyaWVmL2FmZmlsaWF0aW9uLWJyaWVmLmNvbXBvbmVudC50cy5BZmZpbGlhdGlvbkJyaWVmQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPHN0cm9uZz57eyBhZmZpbGlhdGlvbi5sZWdhY3lfSUNOIH19PC9zdHJvbmc+PGJyPlxuPHNtYWxsPlxuICA8c3BhbiAqbmdJZj1cImlzTm90RW1wdHkoYWZmaWxpYXRpb24uSUNOKVwiPnt7YWZmaWxpYXRpb24uSUNOWzBdfX08YnI+PC9zcGFuPlxuICA8c3BhbiAqbmdJZj1cImlzTm90RW1wdHkoYWZmaWxpYXRpb24uaW5zdGl0dXRpb25fbmFtZXMpXCI+e3thZmZpbGlhdGlvbi5pbnN0aXR1dGlvbl9uYW1lc1swXX19PGJyPjwvc3Bhbj5cbjwvc21hbGw+IiwiPHJlLWFmZmlsaWF0aW9uLWJyaWVmPjwvcmUtYWZmaWxpYXRpb24tYnJpZWY+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7OztvQkNFRTtNQUFBLHdFQUEwQzthQUFBLDJCQUFzQjtNQUFBO01BQUE7O0lBQXRCO0lBQUE7Ozs7b0JBQzFDO01BQUEsd0VBQXdEO2FBQUEsMkJBQW9DO01BQUE7TUFBQTs7SUFBcEM7SUFBQTs7OztvQkFIMUQ7TUFBQSx3RUFBUTthQUFBLDJCQUFxQztNQUFBO01BQUEsZ0JBQUksMENBQ2pEO01BQUE7TUFBQSw0Q0FBTztNQUFBLFdBQ0w7TUFBQSwwQ0FBQTtvQkFBQSxtQ0FBMkU7TUFBQSxXQUMzRTtNQUFBLDBDQUFBO01BQUEsc0VBQXVHO2FBQUE7O0lBRGpHO0lBQU4sV0FBTSxTQUFOO0lBQ007SUFBTixZQUFNLFNBQU47OztJQUhNO0lBQUE7Ozs7b0JDQVI7TUFBQTswQ0FBQSxVQUFBO01BQUE7Ozs7In0=



// WEBPACK FOOTER //
// /home/travis/build/inspirehep/record-editor/src/$$_gendir/app/shared/components/affiliation-brief/affiliation-brief.component.ngfactory.ts